export const namespace =
  'canalplus.block.oneshop.updating_options_select_payment_method';
export { default as Component } from './components/MobileMoneyForm';
export { default as propsFormatter } from './propsFormatter';
